module.exports = __webpack_public_path__ + "static/media/DAI.1a84a86b.svg";